import { $t } from '@/utils/languageAuto';

var render = function () {
  var _vm = this;

  var _h = _vm.$createElement;

  var _c = _vm._self._c || _h;

  return _c('div', {
    staticClass: "login-background login-container"
  }, [_c('div', {
    staticClass: "login-main"
  }, [_c('img', {
    staticClass: "login-logo",
    attrs: {
      "src": require("@/assets/images/logo.png")
    }
  }), _vm.step === _vm.$enum.oauth.Step.WAIT_LOGIN ? _c('a-card', {
    staticClass: "login-box"
  }, [_c('a-form-model', {
    ref: "formDataRef",
    attrs: {
      "model": _vm.formData,
      "rules": _vm.formDataRule
    }
  }, [_c('a-form-model-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('a-input', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "size": "large",
      "placeholder": _vm.t('账号')
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.handleEnter($event);
      }
    },
    model: {
      value: _vm.formData.account,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "account", $$v);
      },
      expression: "formData.account"
    }
  }, [_c('a-icon', {
    attrs: {
      "slot": "prefix",
      "type": "user"
    },
    slot: "prefix"
  })], 1)], 1), _c('a-form-model-item', {
    attrs: {
      "prop": "password"
    }
  }, [_c('a-input', {
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "type": "password",
      "size": "large",
      "placeholder": _vm.t('请输入密码')
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.handleEnter($event);
      }
    },
    model: {
      value: _vm.formData.password,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "password", $$v);
      },
      expression: "formData.password"
    }
  }, [_c('a-icon', {
    attrs: {
      "slot": "prefix",
      "type": "lock"
    },
    slot: "prefix"
  })], 1)], 1), _vm.showCaptcha ? _c('a-form-model-item', {
    attrs: {
      "prop": "image_validation_code"
    }
  }, [_c('a-input-group', {
    attrs: {
      "compact": ""
    }
  }, [_c('a-input', {
    staticStyle: {
      "width": "70%"
    },
    attrs: {
      "fbu-invalid-analyse-tag": true,
      "size": "large",
      "placeholder": _vm.t('请输入验证码')
    },
    on: {
      "keyup": function ($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) {
          return null;
        }

        return _vm.handleEnter($event);
      }
    },
    model: {
      value: _vm.formData.image_validation_code,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "image_validation_code", $$v);
      },
      expression: "formData.image_validation_code"
    }
  }), _c('a-spin', {
    staticClass: "login-validate-code",
    attrs: {
      "spinning": _vm.validateCodeImageLoading
    }
  }, [_c('img', {
    staticStyle: {
      "width": "100%",
      "height": "100%"
    },
    attrs: {
      "src": _vm.validateCodeImageUrl,
      "data-permission": "oauth_authorize_image_validation_code",
      "id": "oauth_authorize_image_validation_code"
    },
    on: {
      "click": _vm.handleSwitchImageValidateCode
    }
  })])], 1)], 1) : _vm._e(), _c('div', {
    staticStyle: {
      "text-align": "right",
      "margin-top": "-15px"
    }
  }, [_c('a', {
    attrs: {
      "href": "/forget_password",
      "data-permission": "oauth_authorize_forget_password",
      "id": "oauth_authorize_forget_password",
      "target": "_blank",
      "fbu-analyse-name": $t("\u5FD8\u8BB0\u5BC6\u7801?")
    }
  }, [_c('a-button', {
    attrs: {
      "type": "link",
      "fbu-analyse-name": $t("\u5FD8\u8BB0\u5BC6\u7801?")
    }
  }, [_vm._v(_vm._s(_vm.t('忘记密码?')))])], 1)]), _c('a-button', {
    staticClass: "margin-top",
    attrs: {
      "size": "large",
      "data-permission": "oauth_authorize_submit",
      "id": "oauth_authorize_submit",
      "type": "primary",
      "loading": _vm.loginLoading,
      "block": "",
      "fbu-analyse-name": $t("\u767B\u5F55")
    },
    on: {
      "click": _vm.handleLogin
    }
  }, [_vm._v(_vm._s(_vm.t('登录')))])], 1)], 1) : _vm.step === _vm.$enum.oauth.Step.WAIT_OAUTH ? _c('div', {
    staticClass: "msg-box"
  }, [_c('h4', [_vm._v(_vm._s(_vm.t('是否允许{0}访问您的谷仓账户？', [_vm.platformName])))]), _c('p', [_vm._v(_vm._s(_vm.t('单击下方的允许按钮，即代表允许{0}访问您的谷仓账户信息（包含相关的个人数据），并执行与账户相关的操作，包括查询主体账户余额，向主体账户充值等。', [_vm.platformName])))]), _c('div', {
    staticClass: "msg-tool",
    staticStyle: {
      "margin-top": "150px"
    }
  }, [_c('div', [_c('a-button', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.oauthLoading,
      "data-permission": "oauth_authorize_oauth",
      "id": "oauth_authorize_oauth",
      "fbu-analyse-name": $t("\u5141\u8BB8")
    },
    on: {
      "click": _vm.handleOauth
    }
  }, [_vm._v(_vm._s(_vm.t('允许')))])], 1), _c('div', {
    staticClass: "mt-10"
  }, [_c('a-button', {
    staticStyle: {
      "width": "200px"
    },
    attrs: {
      "data-permission": "oauth_authorize_cancel",
      "id": "oauth_authorize_cancel"
    },
    on: {
      "click": _vm.handleCancel
    }
  }, [_vm._v(_vm._s(_vm.isSubWindow() ? _vm.t('取消') : _vm.t('返回')))])], 1)])]) : _vm.step === _vm.$enum.oauth.Step.OAUTH_SUCCESS ? _c('div', {
    staticClass: "msg-box tc"
  }, [_c('a-icon', {
    staticClass: "msg-icon",
    staticStyle: {
      "color": "#006AD4"
    },
    attrs: {
      "type": "check-circle"
    }
  }), _c('p', {
    staticClass: "mt-20"
  }, [_vm._v(_vm._s(_vm.t('授权成功，{0}当前已可访问您的谷仓账户。', [_vm.platformName])))]), _c('div', {
    staticClass: "msg-tool"
  }, [_c('a-button', {
    staticClass: "mt-30",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "primary",
      "data-permission": "oauth_authorize_confirm",
      "id": "oauth_authorize_confirm",
      "fbu-analyse-name": $t("\u786E\u5B9A")
    },
    on: {
      "click": _vm.handleConfirm
    }
  }, [_vm._v(_vm._s(_vm.t('确定')))])], 1)], 1) : _vm.step === _vm.$enum.oauth.Step.OAUTH_FAIL ? _c('div', {
    staticClass: "msg-box tc"
  }, [_c('a-icon', {
    staticClass: "msg-icon",
    staticStyle: {
      "color": "red"
    },
    attrs: {
      "theme": "filled",
      "type": "close-circle"
    }
  }), _c('p', [_vm._v(_vm._s(_vm.t('授权失败，当前{0}账户未在谷仓进行授权，请先到谷仓-付款账户信息中创建{0}的付款账户并进行授权。', [_vm.platformName])))]), _c('div', {
    staticClass: "msg-tool"
  }, [_c('a-button', {
    staticClass: "mt-30",
    staticStyle: {
      "width": "300px"
    },
    attrs: {
      "type": "primary",
      "data-permission": "oauth_authorize_close",
      "id": "oauth_authorize_close"
    },
    on: {
      "click": _vm.handleBack
    }
  }, [_vm.isSubWindow() ? _c('span', [_vm._v(_vm._s(_vm.t('关闭')))]) : _c('span', [_vm._v(_vm._s(_vm.t('返回首页')))])])], 1)], 1) : _vm._e()], 1), _c('v-footer')], 1);
};

var staticRenderFns = [];
export { render, staticRenderFns };